// @ts-nocheck -- recovered 2023 source is compiled against reconstructed dependency versions.
import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { authenticateToken, signUp } from "../../redux/actions/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { TypeOf } from "zod";
import FlashMessage from "../../components/Flashmessage";
import { loadGenearlSettings } from "../../redux/actions/settings.actions";
import DilogBox from "../../components/Dilogbox";
import { Link as RouterLink } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  Stack,
  Select,
  MenuItem,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { green } from "@mui/material/colors";
import TokenService from "../../utility";
import { baseStyleType } from "../facility/facility-form";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { storeStateType } from "../../redux/store";
import { siteSettingsType } from "../../redux/reducers/settings.reducer";
import Loading from "react-loading";
import { DatePicker } from "@mui/x-date-pickers-pro";
import moment from "moment";
import {
  AUSTRALIA_AUTOCOMPLETION_REQUEST,
  AUSTRALIAN_ADDRESS_ERROR,
  resolveAustralianPlace,
  serializeAustralianAddress,
} from "../../components/AustralianAddress";

const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Others", value: "others" },
];

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://rosterme.io/">
        Rosterme.io
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

type FieldsName = {
  field_label: string;
  field_slug: string;
  field_type: string;
  required_field: string;
  field_options?: string;
  select_options?: { label: string; value: string }[];
  file_extensions?: any;
  visa_type_options?: { label: string; value: string }[];
  not_custom_fields?: boolean;
}[];

type customFieldsPair = {
  info_value: any;
  customfield: number;
  paramaters?: any;
}[];

interface State {
  password: string;
  showPassword: boolean;
}

const SignUp: React.FunctionComponent = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accepted, data, loading } = useSelector(
    (state: storeStateType) => state.auth
  );
  const uiLoading = useSelector((state: any) => state.UI.loading);

  const uiError = useSelector((state: any) => state.UI.errors);
  const globalSettings = useSelector(
    (state: any) => state.sitesetting.settings
  );
  const [values, setValues] = React.useState<State>({
    password: "",
    showPassword: false,
  });
  const [open, setOpen] = useState(false);
  const [siteSttings, setSiteSettings] = useState<siteSettingsType>();
  const [pfields, setPfields] = useState<FieldsName>([]);
  const [pextensions, setPextensions] = useState<string[]>([]);
  const [accept, setAccept] = useState(false);

  const visaSelectOptions = React.useMemo(
    () => [
      { label: "Student Visa", value: "student-visa" },
      { label: "Permanent Resident", value: "permanent-resident" },
      { label: "Australian Citizen", value: "australian-citizen" },
      { label: "Other Visa Type", value: "other-visa-type" },
    ],
    []
  );

  const profileFields: FieldsName = React.useMemo(() => {
    if (siteSttings?.["enable_visa_type_info"])
      return [
        {
          field_label: "Token",
          field_slug: "token",
          field_type: "hidden",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_label: "Full Name",
          field_slug: "fullname",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_label: "Email Address",
          field_slug: "email",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_label: "Date of Birth",
          field_slug: "date_of_birth",
          field_type: "date",
          required_field: "1",
          not_custom_fields: true,
        },
        {
          field_label: "Select Gender",
          field_slug: "gender",
          field_type: "select-option",
          required_field: "1",
          not_custom_fields: true,
          select_options: genderOptions,
        },

        {
          field_slug: "mobile_number",
          field_label: "Mobile Number",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_slug: "address",
          field_label: "Address",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },
        {
          field_slug: "visa_type",
          field_label: "Visa Type",
          field_type: "visa_type",
          visa_type_options: visaSelectOptions,
          required_field: "1",
          not_custom_fields: true,
        },
        {
          field_slug: "password",
          field_label: "Mobile Number",
          field_type: "password",
          required_field: "1",
          not_custom_fields: true,
        },
      ];
    else {
      return [
        {
          field_label: "Token",
          field_slug: "token",
          field_type: "hidden",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_label: "Full Name",
          field_slug: "fullname",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_label: "Email Address",
          field_slug: "email",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },
        {
          field_label: "Date of Birth",
          field_slug: "date_of_birth",
          field_type: "date",
          required_field: "1",
          not_custom_fields: true,
        },
        {
          field_label: "Select Gender",
          field_slug: "gender",
          field_type: "select-option",
          required_field: "1",
          not_custom_fields: true,
          select_options: genderOptions,
        },
        {
          field_slug: "mobile_number",
          field_label: "Mobile Number",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_slug: "address",
          field_label: "Address",
          field_type: "text",
          required_field: "1",
          not_custom_fields: true,
        },

        {
          field_slug: "password",
          field_label: "Mobile Number",
          field_type: "password",
          required_field: "1",
          not_custom_fields: true,
        },
      ];
    }
  }, [visaSelectOptions, siteSttings]);

  const fileTypes: string[] = React.useMemo(() => [], []);

  const useCustomFieldsExtendValidation = (customFields: any) => {
    return customFields.map((customField: any) => {
      switch (customField.field_type) {
        case "text":
        case "textarea":
        case "select":
        case "date":
        case "password":
          if (Number(customField.required_field) === 1) {
            return {
              ...customField,
              validationType: "string",
              validations: [
                {
                  type: "required",
                  params: ["This field is required"],
                },
              ],
            };
          } else {
            return customField;
          }
        case "multiple":
          if (Number(customField.required_field) === 1) {
            return {
              ...customField,
              validationType: "array",
              validations: [
                {
                  type: "min",
                  params: [1, "This field is required"],
                },
              ],
            };
          } else {
            return customField;
          }

        case "file":
          if (Number(customField.required_field) === 1) {
            return {
              ...customField,
              validationType: "mixed",
              validations: [
                {
                  type: "test",
                  params: [
                    "required",
                    "File is required",
                    (file: any) => {
                      return file.length >= 1;
                    },
                  ],
                },
                {
                  type: "test",
                  params: [
                    "fileSize",
                    "File size too large, max file size is 1 Mb",
                    (file: any) => {
                      return file.length >= 1 && file[0].size <= 1100000;
                    },
                  ],
                },
                {
                  type: "test",
                  params: [
                    "fileType",
                    "Incorrect file type",
                    (file: any) => {
                      return (
                        file.length >= 1 &&
                        pextensions.includes(file[0].type as never)
                      );
                    },
                  ],
                },
              ],
            };
          } else {
            return customField;
          }

        default:
          return customField;
      }
    });
  };
  const useCustomFieldsDynamicSchema = (schema: any, config: any) => {
    const { field_slug, validationType, validations = [] } = config;
    if (!yup[validationType as keyof typeof yup]) {
      return schema;
    }
    const yupMethod = validationType as keyof typeof yup;
    let validator = yup[yupMethod] as Function;
    validator = validator();

    validations?.forEach((validation: any) => {
      const { params, type } = validation;
      if (!validator[type as keyof typeof validator]) {
        return;
      }
      validator = validator[type as keyof typeof validator](...params);
    });
    schema[field_slug] = validator;
    return schema;
  };

  const dynamicFormData = useCustomFieldsExtendValidation(pfields);
  const customFieldsSchema = dynamicFormData.reduce(
    useCustomFieldsDynamicSchema,
    {}
  );

  const dynamicValidationSchema = yup.object().shape(customFieldsSchema);

  const {
    formState: { errors },
    register,
    setError,
    clearErrors,
    watch,
    handleSubmit,
    control,
  } = useForm<TypeOf<typeof customFieldsSchema>>({
    defaultValues: {},
    resolver: yupResolver(dynamicValidationSchema), // Here we use our dynamic schema
  });
  console.log(errors);

  useEffect(() => {
    dispatch<any>(authenticateToken(token, navigate));
    dispatch<any>(loadGenearlSettings());
  }, [dispatch, navigate, token]);

  useEffect(() => {
    if (globalSettings) {
      globalSettings?.forEach((item: any) => {
        if (item["config_name"] === "site") {
          setSiteSettings(JSON.parse(item["config_value"]));
        }
        if (item["config_name"] === "employee") {
          TokenService.saveEmloyeeSettings(item["config_value"]);
          //window.localStorage.setItem('employeeSettings', item['config_value'])
        }
      });
    }
  }, [globalSettings]);

  useEffect(() => {
    if (data) {
      data.employeefields?.forEach((opts: any) => {
        profileFields.push(opts);

        if (opts.file_extensions) {
          opts.file_extensions.split(",")?.forEach((ext: any) => {
            switch (ext) {
              case "jpg":
                fileTypes.push("image/jpg");
                fileTypes.push("image/jpeg");
                break;
              case "png":
                fileTypes.push("image/png");
                break;
              case "gif":
                fileTypes.push("image/png");
                break;
              case "doc":
                fileTypes.push("application/msword");
                fileTypes.push(
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                );
                break;

              case "odt":
                fileTypes.push("application/vnd.oasis.opendocument.text");
                break;
              case "pdf":
                fileTypes.push("application/pdf");
                break;
              case "csv":
                fileTypes.push("text/csv");
                break;
              case "text":
                fileTypes.push("text/plain");
                break;
              case "xls":
                fileTypes.push("text/vnd.ms-excel");
                fileTypes.push(
                  "text/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                break;
            }
          });
        }
      });
      setPfields(profileFields);
      setPextensions(fileTypes);
    }
  }, [data, token, fileTypes, profileFields]);

  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
    };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  // const onSubmitOld: SubmitHandler<TypeOf<typeof customFieldsSchema>> = postdata => {
  //   const infos: customFieldsPair = [];
  //   data.employeefields?.forEach((cfield: any) => {
  //     if (postdata[cfield.field_slug]) {
  //       if (postdata[cfield.field_slug] instanceof FileList) {
  //         for (const value of postdata[cfield.field_slug]) {
  //           //formdata.append(cfield.field_slug, value);
  //           infos.push({ info_value: value.name, customfield: cfield.id })
  //         }
  //       } else if (Array.isArray(postdata[cfield.field_slug]) && postdata[cfield.field_slug].length > 0) {
  //         infos.push({ info_value: postdata[cfield.field_slug].join(','), customfield: cfield.id })
  //       } else {
  //         infos.push({ info_value: postdata[cfield.field_slug], customfield: cfield.id })
  //       }
  //     }
  //     if (infos.length > 0) {
  //       postdata.infos = infos
  //     }
  //   })

  //   dispatch<any>(signUp(postdata, token, navigate));
  // }

  const onSubmit: SubmitHandler<TypeOf<typeof customFieldsSchema>> = (
    postdata
  ) => {
    console.log("hitting post and PostData is ", postdata);
    const infos: customFieldsPair = [];
    const formdata = new FormData();
    let err = false;
    if (postdata.hasOwnProperty("gender")) {
      if (!postdata["gender"]) {
        err = true;
        setError("gender", {
          type: "manual",
          message: "Please select gender",
        });
      }
    }
    if (postdata["visa_type"] === "other-visa-type") {
      if (!postdata["other-visa-type"]) {
        err = true;
        setError("other-visa-type", {
          type: "manual",
          message: "Please enter other visa",
        });
      } else {
        formdata.append("other-visa-type", postdata["other-visa-type"]);
      }
    }
    if (postdata["date_of_birth"]) {
      let dateMoment = moment(postdata["date_of_birth"]);
      let currentDate = moment();
      if (currentDate?.subtract(1, "months").isBefore(dateMoment)) {
        err = true;
        setError("date_of_birth", {
          type: "manual",
          message: "Please enter valid DOB",
        });
      }
    }
    if (err) {
      return false;
    }
    pfields?.forEach((field) => {
      if (postdata[field.field_slug] && field.not_custom_fields) {
        formdata.append(field.field_slug, postdata[field.field_slug]);
      }
    });

    data.employeefields?.forEach((cfield: any) => {
      if (postdata[cfield.field_slug]) {
        if (postdata[cfield.field_slug] instanceof FileList) {
          for (const value of postdata[cfield.field_slug]) {
            formdata.append(cfield.field_slug, value);
            infos.push({
              info_value: value.name,
              customfield: cfield.id,
              paramaters: value.type,
            });
          }
        } else if (
          Array.isArray(postdata[cfield.field_slug]) &&
          postdata[cfield.field_slug].length > 0
        ) {
          infos.push({
            info_value: postdata[cfield.field_slug].join(","),
            customfield: cfield.id,
          });
        } else {
          infos.push({
            info_value: postdata[cfield.field_slug],
            customfield: cfield.id,
          });
        }
      }
    });
    if (infos.length > 0) {
      formdata.append("infos", JSON.stringify(infos));
      postdata.infos = infos;
    }
    dispatch<any>(signUp(formdata, token, navigate));
  };

  const onConfirm = () => {
    setOpen(false);
  };

  const customStyles = !errors["address"]
    ? {
        control: (baseStyles: baseStyleType) => ({
          ...baseStyles,
          padding: "10px 4px",
          borderColor: "rgba(0, 0, 0, 0.2)",
          boxShadow: 0,
        }),
        input: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "-9px",
          pointer: "cursor",
          padding: "0 10px ",
        }),

        singleValue: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "-9px",
          padding: "0 10px ",
        }),
      }
    : {
        control: (provided: baseStyleType) => ({
          ...provided,
          padding: "10px 10px",
          borderColor: "#fb6340",
        }),
        input: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "-9px",
          padding: 0,
        }),
      };

  return (
    <>
      {!loading && accepted && (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "left",
              }}
            >
              <DilogBox
                isDialogOpened={open}
                handleConfirmDialog={onConfirm}
                handleCloseDialog={onConfirm}
                message={
                  <Box sx={{ whiteSpace: "pre-line" }}>
                    {siteSttings?.terms_cond}
                  </Box>
                }
                disableNo={true}
                dilogTitle="Terms & Conditions"
                actionBtn="Accept"
              />

              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign up
              </Typography>
              <FlashMessage />
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit(onSubmit)}
                sx={{ mt: 3 }}
              >
                <Grid container spacing={2}>
                  {pfields.length > 0 &&
                    pfields.map((pfield, index) => {
                      if (pfield.field_type === "hidden")
                        return (
                          <TextField
                            required={
                              Number(pfield.required_field) === 1 ? true : false
                            }
                            id={`hidden-${index}`}
                            key={`hidden-${index}`}
                            sx={{ display: "none" }}
                            type="hidden"
                            {...register(pfield.field_slug)}
                            value={token}
                          />
                        );

                      if (pfield.field_type === "text") {
                        if (pfield.field_slug === "address") {
                          return (
                            <Grid
                              item
                              xs={12}
                              key={`grid-text-${index}`}
                              sx={{ zIndex: 2 }}
                            >
                              <FormControl
                                fullWidth
                                variant="standard"
                                error={!!errors[pfield.field_slug]}
                              >
                                <InputLabel htmlFor={pfield.field_label}>
                                  {pfield.field_label}
                                </InputLabel>

                                <Controller
                                  control={control}
                                  name={pfield.field_slug}
                                  render={({ field: { onChange, value } }) => (
                                    <GooglePlacesAutocomplete
                                      apiKey={
                                        process.env
                                          .REACT_APP_GOOGLE_AUTOCOMPLETE_KEY
                                      }
                                      autocompletionRequest={
                                        AUSTRALIA_AUTOCOMPLETION_REQUEST
                                      }
                                      selectProps={{
                                        placeholder: `${pfield.field_label}*`,
                                        defaultInputValue: value,
                                        isClearable: true,

                                        onChange: async (address: any) => {
                                          if (!address) {
                                            onChange("");
                                            return;
                                          }
                                          try {
                                            const details =
                                              await resolveAustralianPlace(
                                                address?.value?.place_id
                                              );
                                            onChange(
                                              serializeAustralianAddress(details)
                                            );
                                            clearErrors(pfield.field_slug);
                                          } catch {
                                            onChange("");
                                            setError(pfield.field_slug, {
                                              type: "manual",
                                              message: AUSTRALIAN_ADDRESS_ERROR,
                                            });
                                          }
                                        },
                                        styles: customStyles,
                                      }}
                                    />
                                  )}
                                />
                                <FormHelperText id="facility_address_errror_message">
                                  {errors[pfield.field_slug]
                                    ? String(
                                        errors[pfield.field_slug]?.message ?? ""
                                      )
                                    : ""}
                                </FormHelperText>
                              </FormControl>
                            </Grid>
                          );
                        } else
                          return (
                            <Grid item xs={12} key={`grid-text-${index}`}>
                              <TextField
                                required={
                                  Number(pfield.required_field) === 1
                                    ? true
                                    : false
                                }
                                fullWidth
                                id={`text-${index}`}
                                key={`text-${index}`}
                                label={pfield.field_label}
                                {...register(pfield.field_slug)}
                                error={!!errors[pfield.field_slug]}
                                helperText={String(
                                  errors[pfield.field_slug]?.message ?? ""
                                )}
                              />
                            </Grid>
                          );
                      }

                      if (pfield.field_type === "textarea")
                        return (
                          <Grid xs={12} key={`grid-textarea -${index}`}>
                            <TextField
                              required={
                                Number(pfield.required_field) === 1
                                  ? true
                                  : false
                              }
                              id={`fields-${index}`}
                              key={`fields-${index}`}
                              label={pfield.field_label}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fullWidth
                              multiline
                              rows={3}
                              {...register(pfield.field_slug)}
                              error={!!errors[pfield.field_slug]}
                              helperText={String(
                                errors[pfield.field_slug]?.message ?? ""
                              )}
                            />
                          </Grid>
                        );
                      if (pfield.field_type === "date")
                        return (
                          <Grid item xs={12} key={`grid-date-${index}`}>
                            <Controller
                              control={control}
                              name={pfield.field_slug}
                              render={({ field: { onChange, value } }) => (
                                <>
                                  <DatePicker
                                    sx={{ width: "100%" }}
                                    label={pfield.field_label}
                                    onChange={(valueObj) => {
                                      onChange(valueObj?.format("YYYY-MM-DD"));
                                    }}
                                    value={value ? moment(value) : null}
                                    format="YYYY-MM-DD"
                                    maxDate={moment().subtract(1, "months")}
                                  />
                                  <FormHelperText
                                    error={!!errors[pfield.field_slug]}
                                  >
                                    {String(
                                      errors[pfield.field_slug]?.message ?? ""
                                    )}
                                  </FormHelperText>
                                </>
                              )}
                            />

                            {/* <TextField
                              id={pfield.field_slug}
                              margin="dense"
                              fullWidth
                              label={pfield.field_label}
                              placeholder="--"
                              required
                              type="date"
                              defaultValue=""
                              {...register(pfield.field_slug)}
                              error={!!errors[pfield.field_slug]}
                              helperText={String(
                                errors[pfield.field_slug]?.message ?? ""
                              )}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            /> */}
                          </Grid>
                        );
                      if (pfield.field_type === "password")
                        return (
                          <Grid item xs={12} key={`grid-password-${index}`}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              error={!!errors["password"]}
                            >
                              <InputLabel htmlFor={`password-${index}`}>
                                Password *
                              </InputLabel>
                              <OutlinedInput
                                id={`password-${index}`}
                                key={`password-${index}`}
                                type={values.showPassword ? "text" : "password"}
                                value={values.password}
                                {...register("password")}
                                onChange={handleChange("password")}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                    >
                                      {values.showPassword ? (
                                        <VisibilityOff />
                                      ) : (
                                        <Visibility />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                }
                                label="Password *"
                              />
                              <FormHelperText>
                                {errors["password"]
                                  ? errors["password"].message
                                  : ""}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        );

                      if (pfield.field_type === "select-option")
                        return (
                          <Grid item xs={12} key={`grid-select-${index}`}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              sx={{ mt: 1 }}
                              error={!!errors[pfield.field_slug]}
                            >
                              <InputLabel id="role-select-label">
                                {pfield.field_label}
                              </InputLabel>
                              <Controller
                                name={pfield.field_slug}
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    required={true}
                                    defaultValue="1"
                                    labelId={pfield.field_slug}
                                    className="input-container"
                                    id={pfield.field_label}
                                    key={pfield.field_label}
                                    label={pfield.field_label}
                                    value={value}
                                    onChange={onChange}
                                  >
                                    {pfield.select_options &&
                                      pfield.select_options.map(
                                        (option: any, i: number) => (
                                          <MenuItem
                                            key={`option-${i}`}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </MenuItem>
                                        )
                                      )}
                                  </Select>
                                )}
                              />
                              <FormHelperText>
                                {String(
                                  errors[pfield.field_slug]?.message ?? ""
                                )}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        );

                      if (pfield.field_type === "select")
                        return (
                          <Grid item xs={12} key={`grid-select-${index}`}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              sx={{ mt: 1 }}
                              error={!!errors[pfield.field_slug]}
                            >
                              <InputLabel id="role-select-label">
                                {pfield.field_label}
                              </InputLabel>
                              <Controller
                                name={pfield.field_slug}
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    defaultValue="1"
                                    labelId={pfield.field_slug}
                                    className="input-container"
                                    id={pfield.field_label}
                                    key={pfield.field_label}
                                    label={pfield.field_label}
                                    value={value}
                                    onChange={onChange}
                                  >
                                    {pfield.field_options &&
                                      pfield.field_options
                                        .split(",")
                                        .map((c: any, i: number) => (
                                          <MenuItem key={`c-${i}`} value={c}>
                                            {c}
                                          </MenuItem>
                                        ))}
                                  </Select>
                                )}
                              />
                              <FormHelperText>
                                {String(
                                  errors[pfield.field_slug]?.message ?? ""
                                )}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        );

                      if (pfield.field_type === "visa_type")
                        return (
                          <Grid item xs={12} key={`grid-select-${index}`}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              error={!!errors[pfield.field_slug]}
                            >
                              <InputLabel id="role-select-label">
                                {pfield.field_label}
                              </InputLabel>
                              <Controller
                                name={pfield.field_slug}
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    defaultValue="1"
                                    labelId={pfield.field_slug}
                                    className="input-container"
                                    id={pfield.field_label}
                                    key={pfield.field_label}
                                    label={pfield.field_label}
                                    sx={{ textAlign: "start" }}
                                    value={value}
                                    onChange={(value) => {
                                      onChange(value);
                                    }}
                                  >
                                    {pfield.visa_type_options &&
                                      pfield.visa_type_options.map(
                                        (option: any) => {
                                          return (
                                            <MenuItem
                                              key={`option-${option.value}`}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                  </Select>
                                )}
                              />
                              {watch("visa_type") === "other-visa-type" && (
                                <>
                                  <TextField
                                    required={true}
                                    id={`other-visa-text`}
                                    key={`other-visa-text`}
                                    label={"Other Visa"}
                                    sx={{ mt: "1rem" }}
                                    type="text"
                                    fullWidth
                                    {...register("other-visa-type")}
                                    error={!!errors["other-visa-type"]}
                                    helperText={String(
                                      errors["other-visa-type"]?.message ?? ""
                                    )}
                                  />
                                </>
                              )}
                            </FormControl>
                          </Grid>
                        );

                      if (pfield.field_type === "multiple")
                        return (
                          <Grid xs={12} key={`grid-multiselect-${index}`}>
                            <Controller
                              name={pfield.field_slug}
                              control={control}
                              defaultValue={[]}
                              render={({ field }) => (
                                <FormControl
                                  fullWidth
                                  variant="outlined"
                                  sx={{ mt: 1 }}
                                  error={!!errors[pfield.field_slug]}
                                >
                                  <InputLabel id="age">
                                    {pfield.field_label}
                                  </InputLabel>
                                  <Select
                                    {...field}
                                    labelId="{field.field_slug"
                                    label="{field.field_label"
                                    multiple
                                    defaultValue={[]}
                                  >
                                    {pfield.field_options &&
                                      pfield.field_options
                                        .split(",")
                                        .map((c: any, i: number) => (
                                          <MenuItem key={`c-${i}`} value={c}>
                                            {c}
                                          </MenuItem>
                                        ))}
                                  </Select>
                                  <FormHelperText>
                                    {String(
                                      errors[pfield.field_slug]?.message ?? ""
                                    )}
                                  </FormHelperText>
                                </FormControl>
                              )}
                            />
                          </Grid>
                        );

                      if (pfield.field_type === "file")
                        return (
                          <Grid
                            xs={12}
                            key={`grid-file-${index}`}
                            sx={{ paddingLeft: "15px", paddingTop: "30px" }}
                          >
                            <TextField
                              required={
                                pfield.required_field === "1" ? true : false
                              }
                              id={`customfield-${index}`}
                              key={`customfield-${index}`}
                              label={pfield.field_label}
                              type="file"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fullWidth
                              {...register(pfield.field_slug)}
                              error={!!errors[pfield.field_slug]}
                              helperText={String(
                                errors[pfield.field_slug]?.message ?? ""
                              )}
                            />
                            <FormHelperText sx={{ ml: 2 }}>
                              Allowed File Types: {pfield.file_extensions}
                            </FormHelperText>
                            <FormHelperText sx={{ ml: 2 }}>
                              Max file size: 1Mb
                            </FormHelperText>
                          </Grid>
                        );

                      return <div></div>;
                    })}
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          value="allowExtraEmails"
                          color="primary"
                          onClick={() => {
                            setAccept(!accept);
                            setOpen(!accept);
                          }}
                        />
                      }
                      label="I accept all terms & conditions."
                    />
                  </Grid>
                </Grid>

                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    disabled={!accept || uiLoading}
                  >
                    Sign Up
                  </Button>
                  {uiLoading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>

                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <Link
                      component={RouterLink}
                      to="/login"
                      variant="body2"
                      sx={{ marginRight: "67px" }}
                    >
                      Already have an account? Sign in
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Copyright sx={{ mt: 5 }} />
          </Container>
        </ThemeProvider>
      )}
      {loading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Stack alignItems="center">
            <Loading type={"bars"} color={"#000000"} height={50} width={50} />
            {/* <CircularProgress /> */}
          </Stack>
        </Box>
      )}

      {!accepted && !loading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <CssBaseline />
          <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
            <Typography variant="h4" component="h1" gutterBottom>
              Invalid token! Please try again
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              {uiError}
            </Typography>
          </Container>
          <Box
            component="footer"
            sx={{
              py: 3,
              px: 2,
              mt: "auto",
              backgroundColor: (theme) =>
                theme.palette.mode === "light"
                  ? theme.palette.grey[200]
                  : theme.palette.grey[800],
            }}
          >
            <Container maxWidth="sm">
              <Copyright />
            </Container>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SignUp;
